import React from 'react';
import './overlay-text-image.css'

const OverlayTextImage = ({title="Add Title", text="Add Text", slogan="Add Text", image="", imageSm="", alt="Descriptive image text" })=> {

    return (
        <div className="overlay-text-image-wrapper relative-position center">
            <picture className="overlay-text-picture">
                <source media="(max-width: 767px)" srcSet={imageSm} />
                <source media="(min-width: 768px)" srcSet={image} />
                <img className="overlay-text-picture"
                    src={image} alt={alt} />
            </picture>
            <div className='overlay-text-content left-align absolute-position popout-slow'>
                <h1>
                    {title}
                </h1>
                <h3>
                    {slogan}
                </h3>
            </div>
            <div className='overlay-bottom-text-content absolute-position center'>
                <h3>
                    {text}
                </h3>
            </div>
        </div>
    )
}

export default OverlayTextImage;
